import React from 'react';
import { getVideoEmbedUrl } from '@/components/CampaignPages/utils/video';
import styles from './VideoPlayer.module.scss';

const VideoPlayer = ({ videoType, videoUrl, posterUrl, autoplay = false }) => {
  if (!videoType || videoType === 'none' || !videoUrl) return null;

  if (videoType === 'uploaded') {
    return (
      <div className={styles.videoWrapper}>
        <video
          src={videoUrl}
          controls
          playsInline
          preload="metadata"
          poster={posterUrl || undefined}
          autoPlay={autoplay}
          className={styles.video}
        />
      </div>
    );
  }

  const embedUrl = getVideoEmbedUrl(videoType, videoUrl, { autoplay });

  if (!embedUrl) return null;

  return (
    <div className={styles.videoWrapper}>
      <div className={styles.iframeWrapper}>
        <iframe
          src={embedUrl}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Campaign video"
          className={styles.iframe}
        />
      </div>
    </div>
  );
};

export default VideoPlayer;
